import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.mixpanel-settings`, {
  'mixology.group': `Group`,
  'mixology.group_plural': `Groups`,
  'mixology.organization': `Organization`,
  'mixology.organization_plural': `Organizations`,
  'mixology.owner': `Owner`,
  'mixology.people': `People`,
  'mixology.project': `Project`,
  'mixology.project-count_one': `1 $t(mixology.project)`,
  'mixology.project-count_other': `{{count}} $t(mixology.project_plural)`,
  'mixology.project_plural': `Projects`,
  'mixology.user': `User`,
  'mixology.user-access.creator': `Creator`,
  'mixology.user-access.editor': `Editor`,
  'mixology.user-access.none': `None`,
  'mixology.user-access.viewer': `Viewer`,
  'mixology.user-count_one': `1 $t(mixology.user)`,
  'mixology.user-count_other': `{{count}} $t(mixology.user_plural)`,
  // refers to user of Mixpanel webapp (rather than tracked user)
  'mixology.user-of-mixpanel': `User`,
  'mixology.user-of-mixpanel_plural': `Users`,
  'mixology.user-role.admin': `Admin`,
  'mixology.user-role.analyst': `Analyst`,
  'mixology.user-role.billing-admin': `Billing Admin`,
  'mixology.user-role.consumer': `Consumer`,
  'mixology.user-role.member': `Member`,
  'mixology.user-role.messenger': `Messenger`,
  'mixology.user-role.owner': `Owner`,
  'mixology.user-role.role': `Role`,
  'mixology.user_plural': `Users`,
  'mixology.viewer': `Viewer`,
  'mixology.workspace': `Workspace`,
  'mixology.workspace_plural': `Workspaces`,
});
